import { createSlice } from "@reduxjs/toolkit";

export const versionSlice = createSlice({
    name: "version",
    initialState: "version",
    reducers: {
        createVersion: (state, action) => {
            return action.payload;
          },
        updateVersion: (state, action) => {
            const result = action.payload;
      
            return result;
          },
          resetVersion: () => {
            
            return "version";
          },
    }
})

export const { createVersion, updateVersion, resetVersion } = versionSlice.actions;

export default versionSlice.reducer;